import { queryAllowances, queryBenefitTypes, queryBenefits } from '@/services/allowances.service';

const Model = {
  namespace: 'featuresAndallowancesAndallowancesList',
  state: {
    page: 1,
    list: [],
    benefits: [],
    benefitTypes: [],
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      yield put({
        type: 'setLoading',
        payload: true,
      });

      try {
        const response = yield call(queryAllowances, payload);
        yield put({
          type: 'queryList',
          payload: response.data,
        });
      } catch (error) {
        yield put({
          type: 'setLoading',
          payload: false,
        });
      }
    },

    *appendFetch({ payload }, { call, put, select }) {
      yield put({
        type: 'setLoading',
        payload: true,
      });
      

      const filters = yield select(
        ({ featuresAndallowancesAndallowancesList }) =>
          featuresAndallowancesAndallowancesList.filters,
      );

      try {
        const response = yield call(queryAllowances, { ...payload, filters });
        yield put({
          type: 'appendList',
          payload: response.data,
        });
      } catch (error) {
        yield put({
          type: 'setLoading',
          payload: false,
        });
      }
    },

    *setFilters({ payload }) {
      yield {
        type: 'setFilters',
        payload,
      };
    },

    *reset({ payload }) {
      yield {
        type: 'resetState',
        payload,
      };
    },

    *fetchBenefitTypes({ payload }, { call, put }) {
      const response = yield call(queryBenefitTypes, payload);
      yield put({
        type: 'queryBenefitTypes',
        payload: response.data,
      });
    },

    *fetchBenefit({ payload }, { call, put }) {
      const response = yield call(queryBenefits, payload);
      yield put({
        type: 'queryBenefits',
        payload: response.data,
      });
    },
  },
  reducers: {
    queryList(state, action) {
      return {
        ...state,
        page: 1,
        isLoading: false,
        total: action.payload.count,
        list: action.payload.results,
      };
    },

    appendList(state, action) {
      return {
        ...state,
        isLoading: false,
        page: state.page + 1,
        list: state.list.concat(action.payload.results),
      };
    },

    setLoading(state, action) {
      return { ...state, isLoading: action.payload };
    },

    setFilters(state, action) {
      return { ...state, filters: action.payload };
    },

    queryBenefitTypes(state, action) {
      return { ...state, benefitTypes: action.payload };
    },

    queryBenefits(state, action) {
      return { ...state, benefits: action.payload };
    },

    resetState() {
      return { page: 1, list: [], benefits: [], benefitTypes: [] };
    },
  },
};
export default Model;
